import { Typography as MuiTypography } from '@mui/material';
import type { TypographyProps as MuiTypographyProps } from '@mui/material/Typography';

export type TypographyProps = MuiTypographyProps;

export const Typography = ({ children, ...props }: Readonly<TypographyProps>) => (
  <MuiTypography {...props}>{children}</MuiTypography>
);
